import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/_app/settings/")({
	component: SettingsIndex,
});

function SettingsIndex() {
	// Redirect to admin-users by default
	return <Navigate to="/app/settings/admin-users" replace />;
}
